<!--
Author: TangChen
Date: 2019-04-08
Desc: 图片上传
 -->
<template>
    <div class="comp-img-upload comp">
        <el-row class="up-list" :span="24">
            <el-form
                v-if="flag === '0'"
                ref="img"
                :model="img"
                :rules="rules"
                v-on:submit.native.prevent
            >
                <el-form-item label="" prop="asset">
                    <div class="title-item">
                        <div class="title-line"></div>
                        <span class="title-content">
                            1、银行开具的不低于300万资产证明（加盖银行业务章）
                        </span>
                    </div>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgCode.asset" class="el-upload-list__item-actions">
                            <i
                                class="el-icon-zoom-in"
                                aria-hidden="true"
                                v-on:click="handlePictureCardPreview('asset')"
                            />
                            <i
                                class="el-icon-delete"
                                aria-hidden="true"
                                v-on:click="delImg('asset')"
                            />
                        </div>
                        <el-upload
                            ref="asset"
                            v-model="imgCode.asset"
                            :action="$util.fileUploadPath('/sale-mid/file/upload')"
                            :accept="accept"
                            :data="$util.fileUploadParam('10')"
                            :headers="$util.fileUploadHeader()"
                            :before-upload="uploadAssetBefore"
                            :on-error="uploadError"
                            :on-success="uploadAssetSuccess"
                            :show-file-list="false"
                            :limit="1"
                        >
                            <div class="img-up">
                                <img v-if="imgCode.asset" :src="scrCode.asset" alt="" />
                                <div v-if="!imgCode.asset" class="upload-img">
                                    <img src="@/assets/img/upload.png" alt="" />
                                </div>
                                <span v-if="!imgCode.asset" class="img-text">资产证明</span>
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="" prop="income">
                    <div class="title-item">
                        <div class="title-line"></div>
                        <span class="title-content">
                            2、近3年个人年均收入不低于30万元的证明（加盖公司公章）
                        </span>
                    </div>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgCode.income" class="el-upload-list__item-actions">
                            <i
                                class="el-icon-zoom-in"
                                aria-hidden="true"
                                v-on:click="handlePictureCardPreview('income')"
                            />
                            <i
                                class="el-icon-delete"
                                aria-hidden="true"
                                v-on:click="delImg('income')"
                            />
                        </div>
                        <el-upload
                            ref="income"
                            v-model="imgCode.income"
                            :action="$util.fileUploadPath('/sale-mid/file/upload')"
                            :accept="accept"
                            :data="$util.fileUploadParam('10')"
                            :headers="$util.fileUploadHeader()"
                            :before-upload="uploadIncomeBefore"
                            :on-error="uploadError"
                            :on-success="uploadIncomeSuccess"
                            :show-file-list="false"
                            :limit="1"
                        >
                            <div class="img-up">
                                <img v-if="imgCode.income" :src="scrCode.income" alt="" />
                                <div v-if="!imgCode.income" class="upload-img">
                                    <img src="@/assets/img/upload.png" alt="" />
                                </div>
                                <span v-if="!imgCode.income" class="img-text">收入证明</span>
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="" prop="invest">
                    <div class="title-item">
                        <div class="title-line"></div>
                        <span class="title-content">
                            3、一年以上证券、基金、期货、基金、外汇等投资经历或者一年以上金融产品设计、投资、风险管理及相关工作经历
                        </span>
                    </div>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgCode.invest" class="el-upload-list__item-actions">
                            <i
                                class="el-icon-zoom-in"
                                aria-hidden="true"
                                v-on:click="handlePictureCardPreview('invest')"
                            />
                            <i
                                class="el-icon-delete"
                                aria-hidden="true"
                                v-on:click="delImg('invest')"
                            />
                        </div>
                        <el-upload
                            ref="invest"
                            v-model="imgCode.invest"
                            :action="$util.fileUploadPath('/sale-mid/file/upload')"
                            :accept="accept"
                            :data="$util.fileUploadParam('10')"
                            :headers="$util.fileUploadHeader()"
                            :before-upload="uploadInvestBefore"
                            :on-error="uploadError"
                            :on-success="uploadInvestSuccess"
                            :show-file-list="false"
                            :limit="1"
                        >
                            <div class="img-up">
                                <img v-if="imgCode.invest" :src="scrCode.invest" alt="" />
                                <div v-if="!imgCode.invest" class="upload-img">
                                    <img src="@/assets/img/upload.png" alt="" />
                                </div>
                                <span v-if="!imgCode.invest" class="img-text">投资经历证明</span>
                            </div>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button class="medium footer-button cancel" v-on:click="$router.back()">
                        还未准备好
                    </el-button>
                    <el-button
                        type="primary"
                        class="medium footer-button apply"
                        v-on:click="submitInfo()"
                    >
                        上传
                    </el-button>
                </el-form-item>
            </el-form>
            <el-form v-else ref="img" :model="img" :rules="rules" v-on:submit.native.prevent>
                <el-form-item label="" prop="qualified">
                    <p class="up-list-mes">1、测试测试测试合格投资者证件照或文件测试测试测试</p>
                    <div class="img-up-list el-upload-list--picture-card">
                        <div v-if="imgBase64.qualified" class="el-upload-list__item-actions">
                            <i
                                class="el-icon-zoom-in"
                                aria-hidden="true"
                                v-on:click="handlePictureCardPreview('qualified')"
                            />
                            <i
                                class="el-icon-delete"
                                aria-hidden="true"
                                v-on:click="delImg('qualified')"
                            />
                        </div>
                        <el-input
                            ref="qualified"
                            v-model="img.qualified"
                            type="file"
                            name="qualified"
                            :accept="accept"
                            v-on:change="getImgBase"
                        />
                        <div class="img-up">
                            <img v-if="imgBase64.qualified" :src="imgBase64.qualified" alt="" />
                            <i
                                v-if="!imgBase64.qualified"
                                class="el-icon-plus"
                                aria-hidden="true"
                            />
                            <span v-if="!imgBase64.qualified" class="img-text">合格投资者证明</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="" class="btn-center">
                    <el-button type="primary" class="medium" v-on:click="submitInfo()">
                        上传
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">还未准备好</el-button>
                </el-form-item>
            </el-form>
            <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
        </el-row>
    </div>
</template>
<script>
import { httpClient } from "@/assets/js/http";
import urls from "@/api/urls";

export default {
    name: "ImgUpload",
    props: {
        flag: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            // accept: "image/jpg,image/jpeg,.doc,.docx",
            accept: "image/jpg,image/jpeg",
            img: {
                idCard: "",
                front: "",
                back: "",
                asset: "",
                invest: "",
                qualified: ""
            },
            imgBase64: {
                front: "",
                back: "",
                asset: "",
                invest: "",
                qualified: ""
            },
            imgCode: {
                income: "",
                asset: "",
                invest: ""
            },
            scrCode: {
                income: "",
                asset: "",
                invest: ""
            },
            rules: {
                idCard: [{ validator: this.validateImg, trigger: "change" }],
                income: [{ validator: this.validateFile, trigger: "change" }],
                asset: [{ validator: this.validateFile, trigger: "change" }],
                invest: [{ validator: this.validateFile, trigger: "change" }],
                qualified: [
                    { required: true, message: "请选择合格投资者文件上传", trigger: "change" }
                ]
            },
            upload_url: "/acct/changetype/upload",
            uploadForm: new FormData()
        };
    },
    watch: {
        "img.front"(val) {
            this.img.idCard = val && this.img.back ? "1" : "";
        },
        "img.back"(val) {
            this.img.idCard = val && this.img.front ? "1" : "";
        }
    },
    mounted() {},
    methods: {
        handlePictureCardPreview(filename) {
            this.dialogImageUrl = this.scrCode[filename];
            this.dialogVisible = true;
        },
        validateImg(rule, value, callback) {
            if (value) {
                callback();
            } else {
                if (!this.img.front && !this.img.back) {
                    callback(new Error("请上传手持身份证正反面文件"));
                }
                if (!this.img.front) {
                    callback(new Error("请上传手持身份证正面文件"));
                }
                if (!this.img.back) {
                    callback(new Error("请上传手持身份证反面文件"));
                }
            }
        },
        validateFile(rule, value, callback) {
            // 校验证明文件
            if (this.imgCode[rule.field]) {
                callback();
            } else {
                if (rule.field == "income") {
                    callback(new Error("请选择收入证明文件上传"));
                } else if (rule.field == "asset") {
                    callback(new Error("请选择资产证明文件上传"));
                } else if (rule.field == "invest") {
                    callback(new Error("请选择投资经历证明文件上传"));
                }
            }
        },
        uploadAssetBefore(file) {
            if (this.checkImageSize(file)) {
                this.scrCode.asset = URL.createObjectURL(file);
            }
        },
        uploadIncomeBefore(file) {
            if (this.checkImageSize(file)) {
                this.scrCode.income = URL.createObjectURL(file);
            }
        },
        uploadInvestBefore(file) {
            if (this.checkImageSize(file)) {
                this.scrCode.invest = URL.createObjectURL(file);
            }
        },
        checkImageSize(file) {
            let maxSize = "1";
            if (file.size > 1024 * 1024 * maxSize) {
                this.headimage = "";
                this.$message.warning("上传文件大小超过限制大小" + maxSize + "M，不能上传");
                return false;
            }
            return true;
        },
        uploadError(err, file, fileList) {
            this.$message.warning(err);
        },
        uploadAssetSuccess(response, file, fileList) {
            this.imgCode.asset = response.body.fileCode;
        },
        uploadIncomeSuccess(response, file, fileList) {
            this.imgCode.income = response.body.fileCode;
        },
        uploadInvestSuccess(response, file, fileList) {
            this.imgCode.invest = response.body.fileCode;
        },
        // async submitInfo () {
        //     const res = await httpClient.post(urls.uploadFile, {
        //         file: this.imgBase64.invest
        //     });
        // },
        submitInfo() {
            const _this = this;
            // _this.upload_url = "/sale-mid/file/upload";
            // const _x = this.$util.src(_this.upload_url,{},true);
            _this.$refs.img.validate((valid) => {
                if (valid) {
                    let list = [
                        {
                            filetype: "108",
                            fileurl: this.imgCode.income,
                            businesscode: "P1"
                        },
                        {
                            filetype: "109",
                            fileurl: this.imgCode.asset,
                            businesscode: "P1"
                        },
                        {
                            filetype: "111",
                            fileurl: this.imgCode.invest,
                            businesscode: "P1"
                        }
                    ];
                    _this.$emit("success", list);
                    // this.$req({
                    //     method: "POST",
                    //     url: _x,
                    //     timeout: 20000,
                    //     data: _this.imgBase64,
                    //     headers: { "Content-Type": "multipart/form-data" }
                    // }).then(res => {
                    //     if (res.code === "0000000") {
                    //         _this.$emit("success", true);
                    //     } else {
                    //         this.$message.error(res.msg);
                    //     }
                    // }).catch(() => { });
                } else {
                    this.$errorScroll();
                }
            });
        },
        getImgBase() {
            const _this = this;
            const event = window.event;
            const file = event.target && event.target.files[0];
            let k = 0;
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            if (
                !(
                    event.target.value.indexOf(".jpg") > -1 ||
                    event.target.value.indexOf(".jpeg") > -1 ||
                    event.target.value.indexOf(".doc") > -1 ||
                    event.target.value.indexOf(".docx") > -1
                )
            ) {
                this.delImg(event.target.name);
                this.$message.warning("只能上传jpg/jpeg,doc/docx文件，请重新上传");
                return false;
            }
            if (file.size > 1024 * 1024) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小1M，不能上传");
                return;
            }
            for (let i in this.img) {
                if (this.img[i] && file.name === this.img[i].split("\\").pop()) k++;
            }
            if (k === 2) {
                this.delImg(event.target.name);
                this.$message.warning("不能上传相同名称的文件，请重新上传");
                return false;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            try {
                this.uploadForm.delete(event.target.name);
            } catch (e) {
                console.log(e);
            }
            this.uploadForm.append(event.target.name, file);
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg(index) {
            this.imgBase64[index] = "";
            this.$refs[index].clearFiles();
            this.scrCode[index] = "";
            this.imgCode[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
                this.uploadForm.delete(index);
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-img-upload {
    .title-item {
        display: flex;
        align-items: center;
        margin-left: 20px;
    }
    .footer-button {
        margin-top: 8px;
        width: 180px;
        height: 42px;
        border-radius: 2px;
    }
    .footer-button:hover {
        border: none;
    }
    .cancel {
        color: #666666;
        background: #e4e4e4;
    }
    .apply {
        margin-left: 40px;
        color: #ffffff;
        background: var(--color-primary);
    }
    .btn-center {
        text-align: center;
    }
    .up-list {
        padding: 24px 0 8px;
        .up-list-mes {
            font-size: $f16;
            color: $text-color2;
            line-height: 30px;
        }
        .el-form-item {
            margin-bottom: 24px;
        }
        .img-up-list {
            margin-top: 12px;
            margin-left: 20px;
            display: inline-block;
            position: relative;
            .el-upload-list__item-actions {
                z-index: 100;
                i {
                    font-size: $f24;
                    cursor: pointer;
                }
                i:last-of-type {
                    margin-left: 20px;
                }
            }
            .el-input {
                position: absolute;
                top: 10px;
                left: 0;
                opacity: 0;
                z-index: 10;
            }
            .img-up,
            .el-input .el-input__inner {
                width: 320px;
                height: 180px;
                cursor: pointer;
            }
            .img-up {
                text-align: center;
                border: 1px dashed #aeaeae;
                border-radius: 6px;
                background-color: #fffaf6;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img {
                    width: 320px;
                    height: 180px;
                    display: inline-block;
                }
            }
            .upload-img {
                width: 34px;
                height: 34px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 17px;
                background-color: var(--color-primary);
                img {
                    width: 18px;
                    height: auto;
                }
            }
            .img-text {
                vertical-align: middle;
                color: #333333;
                font-size: 16px;
            }
            .el-icon-plus {
                vertical-align: middle;
                font-size: $f26;
                margin-right: 7px;
                color: inherit;
                font-weight: bold;
            }
        }
        .img-up-box {
            .img-up-list {
                vertical-align: middle;
                &:last-of-type {
                    margin-left: 24px;
                }
            }
        }
    }
}
</style>
